const STOPPED_LOAD_WINDOW_MILLISECONDS = 1_000;

function navigationTiming(): { loadEventStart: number; domComplete: number } | null {
  if (typeof performance === "undefined") return null;
  if (typeof performance.getEntriesByType !== "function") return null;
  const [entry] = performance.getEntriesByType("navigation");
  if (!entry || !("loadEventStart" in entry) || !("domComplete" in entry)) {
    return null;
  }
  const { loadEventStart, domComplete } = entry;
  if (typeof loadEventStart !== "number" || typeof domComplete !== "number") {
    return null;
  }
  return { loadEventStart, domComplete };
}

export function isDocumentLoadStopped(): boolean {
  if (typeof document === "undefined") return false;
  if (document.readyState !== "complete") return false;
  const timing = navigationTiming();
  if (timing === null) return false;
  return (
    timing.loadEventStart === 0 &&
    timing.domComplete > 0 &&
    performance.now() - timing.domComplete <= STOPPED_LOAD_WINDOW_MILLISECONDS
  );
}
